import { useForm } from "react-hook-form";
import MainContainer from "../../components/container/MainContainer";
import InputField from "../../components/form/InputField";
import SelectField from "../../components/form/SelectField";
import { getTodayDate } from "../../util";
import TextAreaField from "../../components/form/TextAreaField";
import ResourseButtons from "../../components/form/buttons/ResourseButtons";

const CreatePledge = () => {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const onSubmit = async (data, e) => {
    try {
      e.preventDefault();
    } catch (error) {}
  };

  return (
    <MainContainer className="bg-content border border-bkg2">
      <h3 className="p-3">Create Pledge</h3>
      <form
        autoComplete="off"
        onSubmit={handleSubmit(onSubmit)}
        className="flex flex-col px-10 "
      >
        <div className="flex justify-between items-baseline gap-20">
          <SelectField
            register={register}
            name="donor_id"
            label="Organization Name"
            data={[{ id: "", name: "-- Select Donor" }]}
            errors={errors.donor_id}
          />
          <InputField
            register={register}
            name="date"
            label="Date"
            errors={errors.date}
            type="date"
            defaultValue={getTodayDate()}
          />
        </div>
        <div>
          <InputField
            register={register}
            name="name"
            label="Name of Pledger"
            errors={errors.name}
            type="text"
          />
        </div>
        <div className="flex justify-between items-baseline gap-20">
          <InputField
            register={register}
            name="contact"
            label="Contact Number"
            errors={errors.contact}
            type="text"
          />
          <InputField
            register={register}
            name="email"
            label="Email"
            errors={errors.email}
            type="text"
          />
        </div>

        <div>
          <SelectField
            register={register}
            name="pledge_type"
            label="Type of Plledge"
            errors={errors.pledge_type}
            data={[
              { id: "", name: "-- Select Pladge Type" },
              { id: "", name: "Annual" },
              { id: "", name: "Monthly" },
              { id: "", name: "One Time" },
            ]}
          />
        </div>
        <div className="flex justify-between items-baseline gap-20">
          <InputField
            register={register}
            name="amount"
            label="Pledge Amount"
            errors={errors.contact}
            type="number"
          />{" "}
          <div className="flex-1"></div>
        </div>
        <div className="flex justify-between items-baseline gap-20">
          <InputField
            register={register}
            name="date"
            label="Start Date"
            errors={errors.date}
            type="date"
            defaultValue={getTodayDate()}
          />
          <InputField
            register={register}
            name="date"
            label="End Date"
            errors={errors.date}
            type="date"
            defaultValue={getTodayDate()}
          />
        </div>

        <div>
          <TextAreaField
            register={register}
            name="purpose"
            label="Purpose of Pledge"
            errors={errors.purpose}
            type="number"
          />
        </div>
        <div>
          <TextAreaField
            register={register}
            name="purpose"
            label="Special Instruction/Comment"
            errors={errors.purpose}
            type="number"
          />
        </div>

        <ResourseButtons link to="/accounts/transaction" />
      </form>
    </MainContainer>
  );
};

export default CreatePledge;
